import { createApp } from "vue";
import App from "./App.vue";
import $ from "jquery";
import gsap from "gsap";
import routes from "./routes";
import html2pdf from "html2pdf.js";
import "@/assets/css/global.css";
import { useKakao } from 'vue3-kakao-maps/@utils';

// 도메인에 따라 API 키 분기
const kakaoKey = window.location.hostname === 'bodiary.com'
  ? '44b78bb182024ebe7b023b78fa129726'  // 운영
  : '86a4094a537d9b6954cd5afc44babb86'; // 개발 (localhost)

useKakao(kakaoKey, ['clusterer', 'services']);

window.$ = $;
window.gsap = gsap;
window.html2pdf = html2pdf;

const app = createApp(App)

app.use(routes);

app.mount("#app");